/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoDeleteNoteInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type NotesDeleteMutationVariables = {
    input: infoDeleteNoteInput;
};
export type NotesDeleteMutationResponse = {
    readonly infoDeleteNote: {
        readonly clientMutationId: string | null;
    } | null;
};
export type NotesDeleteMutation = {
    readonly response: NotesDeleteMutationResponse;
    readonly variables: NotesDeleteMutationVariables;
};



/*
mutation NotesDeleteMutation(
  $input: infoDeleteNoteInput!
) {
  infoDeleteNote(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoDeleteNotePayload",
    "kind": "LinkedField",
    "name": "infoDeleteNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotesDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotesDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ab7586873b35007fe8a1a31cdc211194",
    "id": null,
    "metadata": {},
    "name": "NotesDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation NotesDeleteMutation(\n  $input: infoDeleteNoteInput!\n) {\n  infoDeleteNote(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '31246ce62d1c63a91d6cde8100c5258f';
export default node;
